module.exports = __webpack_public_path__ + "img/31.4b1f4e69.jpg";